export const HOME = "HOME";
export const PROFILE = "PROFILE";

export const PERSON_ADD = "PERSON_ADD";
export const PERSON_ADD_ADMIN = "PERSON_ADD_ADMIN";
export const PERSON_LIST = "PERSON_LIST";
export const PERSON_LIST_ADMIN = "PERSON_LIST_ADMIN";
export const PERSON_EDIT = "PERSON_EDIT";
export const PERSON_EDIT_ADMIN = "PERSON_EDIT_ADMIN";

export const CAR_CONTRACT_ADD = "CAR_CONTRACT_ADD";
export const CAR_CONTRACT_LIST = "CAR_CONTRACT_LIST";
export const CAR_CONTRACT_LIST_USER = "CAR_CONTRACT_LIST_USER";
export const CAR_CONTRACT_EDIT = "CAR_CONTRACT_EDIT";

export const CHEQUE_ADD = "CHEQUE_ADD";
export const CHEQUE_LIST = "CHEQUE_LIST";
export const CHEQUE_LIST_USER = "CHEQUE_LIST_USER";
export const CHEQUE_LIST_HISTORY = "CHEQUE_LIST_HISTORY";
export const CHEQUE_LIST_CAR_CONTRACT = "CHEQUE_LIST_CAR_CONTRACT";
export const CHEQUE_EDIT = "CHEQUE_EDIT";

export const CHEQUE_CONTRACT_LIST = "CHEQUE_CONTRACT_LIST";
export const CHEQUE_CONTRACT_LIST_USER = "CHEQUE_CONTRACT_LIST_USER";
export const CHEQUE_CONTRACT_ADD = "CHEQUE_CONTRACT_ADD";
export const CHEQUE_CONTRACT_EDIT = "CHEQUE_CONTRACT_EDIT";

export const DEBIT_CREDIT_LIST = "DEBIT_CREDIT_LIST";
export const DEBIT_CREDIT_LIST_USER = "DEBIT_CREDIT_LIST_USER";
export const DEBIT_CREDIT_ADD = "DEBIT_CREDIT_ADD";
export const DEBIT_CREDIT_EDIT = "DEBIT_CREDIT_EDIT";

export const BANK_ACCOUNT_LIST = "BANK_ACCOUNT_LIST";
export const BANK_ACCOUNT_LIST_USER = "BANK_ACCOUNT_LIST_USER";
export const BANK_ACCOUNT_ADD = "BANK_ACCOUNT_ADD";
export const BANK_ACCOUNT_EDIT = "BANK_ACCOUNT_EDIT";

export const LEGAL_ENTITY_LIST = "LEGAL_ENTITY_LIST";
export const LEGAL_ENTITY_LIST_USER = "LEGAL_ENTITY_LIST_USER";
export const LEGAL_ENTITY_ADD = "LEGAL_ENTITY_ADD";
export const LEGAL_ENTITY_EDIT = "LEGAL_ENTITY_EDIT";

export const CONTACT = "CONTACT";
export const REGISTER = "REGISTER";
export const REGISTERCONFIRM = "REGISTERCONFIRM";
export const LOGOUT = "LOGOUT";
export const FORGETPASSWORD = "FORGETPASSWORD";
export const LOGIN = "LOGIN";

export const SETTING_LIST = "SETTING_LIST";
export const SETTING_EDIT = "SETTING_EDIT";
